import { ref, computed } from "vue";
import { autoHideEmptySeries } from "@/Modules/Grafer/autoHideEmptySeries";

export function useChartSeries({
  colorMap = {},
  chartType,
  extractUniqueItems,
  generateColors,
}) {
  const series = ref([]);
  const hiddenSeries = ref(new Set());

  const pieColors = ref([]);
  const pieLegendItems = ref([]);

  const legendItems = computed(() => {
    if (chartType === "pie") return pieLegendItems.value;

    const mapped = series.value.map((serie) => ({
      name: serie.name,
      color: colorMap[serie.name] || null,
    }));

    const missingCount = mapped.filter((item) => !item.color).length;

    if (missingCount > 0) {
      const generated = generateColors(missingCount);
      let i = 0;
      return mapped.map((item) => ({
        name: item.name,
        color: item.color || generated[i++],
      }));
    }

    return mapped;
  });

  const visibleSeries = computed(() =>
    series.value.map((serie, index) => {
      if (hiddenSeries.value.has(index)) {
        return {
          ...serie,
          data: serie.data.map(() => null),
        };
      }
      return serie;
    })
  );

  const toggleSeries = (index) => {
    // Disable toggle functionality for pie charts
    if (chartType === "pie") return;

    const newHidden = new Set(hiddenSeries.value);
    if (newHidden.has(index)) {
      newHidden.delete(index);
    } else {
      newHidden.add(index);
    }
    hiddenSeries.value = newHidden;
  };

  const setSeries = (newSeries) => {
    series.value = newSeries;
    hiddenSeries.value = autoHideEmptySeries(newSeries);
  };

  const setPieData = (rawData) => {
    if (!extractUniqueItems) return;

    const uniqueItems = extractUniqueItems(rawData);
    const useColorMap = Object.keys(colorMap).length > 0;

    if (useColorMap) {
      pieColors.value = uniqueItems.map((item) => colorMap[item] || "#999");
    } else if (generateColors) {
      pieColors.value = generateColors(uniqueItems.length);
    } else {
      pieColors.value = [];
    }

    pieLegendItems.value = uniqueItems.map((name, i) => ({
      name,
      color: pieColors.value[i],
    }));
  };

  return {
    series,
    hiddenSeries,
    visibleSeries,
    legendItems,
    toggleSeries,
    setSeries,
    setPieData,
    pieColors,
  };
}
